<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <saa-s-child-page-container>
    <last-step-button
      @back="back"
    />
    <template v-if="loading">
      <div
        class="text-h3 mt-16"
      >
        {{ $t('AadenProductInfo') }}
      </div>
      <div
        class="mt-8"
        style="width: 100%;"
      >
        <product-card
          v-for="item in productList"
          :key="item.id"
          :checked="selectedProductCode.includes(item.metadata.code)"
          :desc="item.description"
          :name="item.name"
          :one-time="item.realPrice.type"
          :price="item.realPrice.unit_amount/100"
          :read-only="item.readOnly"
          @clickCard="toggle(item.metadata.code)"
        />
      </div>
      <next-step-button
        :style="!$vuetify.breakpoint.mobile ? '' : 'width: 100%; position: relative;'"
        :class="!$vuetify.breakpoint.mobile ? '' : 'btnContentSelect'"
        @next="next"
      >
        <div class="d-block overflow-hidden">
          <div class="d-flex align-center">
            <div
              class="text-truncate"
              style="position: relative;"
            >
              {{ $t('TotalSubPriceInfo') }}
            </div>
            <div
              style="position: relative;"
              class="ml-1"
            >
              {{ totalSubPrice | priceDisplay }}
            </div>
            <div
              class="text-truncate"
              style="position: relative"
            >
              /{{ $t('Monthly') }}
            </div>
            <div
              class="text-truncate"
              style="position: relative;"
            >
              , {{ $t('AndOneTimePayment') }}
            </div>
            <div
              style="position: relative;"
              class="ml-1"
            >
              {{ totalOneTimePrice|priceDisplay }}
            </div>
          </div>
        </div>
      </next-step-button>
    </template>
    <template v-else>
      <div
        class="d-flex align-center justify-center flex-column"
        style="height: 300px"
      >
        <div class="mb-10 text-h3">
          {{ $t('waitAMoment') }}
        </div>
        <v-progress-circular
          indeterminate
          size="48"
        />
      </div>
    </template>
  </saa-s-child-page-container>
</template>

<script>
import LastStepButton from '@/views/SaaS/widget/LastStepButton'
import { loadProducts, ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import ProductCard from '@/views/SaaS/widget/ProductCard.vue'
import sortBy from 'lodash-es/sortBy'
import NextStepButton from '@/views/SaaS/widget/NextStepButton.vue'
import { addProduct, clearProduct, getCurrentSaaSOrderInfo, readOnlyCode } from '@/views/SaaS/SaaSGuide'

export default {
  name: 'OwnChoiceFunctionLicense',
  components: {
    NextStepButton,
    ProductCard,
    SaaSChildPageContainer,
    LastStepButton
  },
  data: function () {
    return {
      loading: false,
      productList: [],
      selectedProductCode: []
    }
  },
  computed: {
    totalOneTimePrice () {
      return (this.realSelectedList.filter(x => x.realPrice.type === 'one_time')
        .map(it => it.realPrice.unit_amount)).reduce(
        (a, b) => {
          return a + b
        }, 0) / 100 ?? 0
    },
    totalSubPrice () {
      return (this.realSelectedList.filter(x => x.realPrice.type !== 'one_time')
        .map(it => it.realPrice.unit_amount)).reduce(
        (a, b) => {
          return a + b
        }, 0) / 100 ?? 0
    },
    realSelectedList () {
      return this.productList.filter(it => this.selectedProductCode.includes(it.metadata.code))
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    toggle (code) {
      if (readOnlyCode.includes(code)) {
        return
      }
      if (this.selectedProductCode.includes(code)) {
        this.selectedProductCode = this.selectedProductCode.filter(it => it !== code)
      } else {
        this.selectedProductCode.push(code)
      }
    },
    async reload () {
      this.loading = false
      const allProducts = await loadProducts()
      const shouldShowCode = [
        ProductCodes.openDevice,
        ProductCodes.base, ProductCodes.tse,
        ProductCodes.restaurant, ProductCodes.advanceSales,
        ProductCodes.staffManagement, ProductCodes.sales,
        ProductCodes.cashbook, ProductCodes.reservation,
        ProductCodes.inventory,
        ProductCodes.cashmanage, ProductCodes.takeawayWeb,
        ProductCodes.scanToOrder, ProductCodes.queneNumber,
        ProductCodes.kitchenMonitor, ProductCodes.hotpotSystem
      ]

      this.selectedProductCode = [
        ProductCodes.base, ProductCodes.openDevice,
        ...getCurrentSaaSOrderInfo().selectedProductList.map(it => it.metadata.code)
      ]
      const sort = {
        openDevice: 2,
        base: 1,
        tse: 3
      }

      this.productList = allProducts.filter(it => shouldShowCode.includes(it.metadata.code)).map(it => {
        it.sort = sort[it.metadata.code] ?? 99
        return it
      })

      this.productList.forEach(it => {
        if ([ProductCodes.base, ProductCodes.openDevice].includes(it.metadata.code)) {
          it.readOnly = true
        }
      })

      this.productList = sortBy(this.productList, (x) => {
        return x.sort
      })
      this.loading = true
    },
    back () {
      this.$router.push({ name: 'recommended' })
    },
    next () {
      clearProduct()
      this.realSelectedList.forEach(it => {
        addProduct(it)
      })
      this.$router.push({ name: 'host' })
    }
  }
}
</script>
